export default __webpack_public_path__ + "static/media/alarm.52a3b010.mp3";